<div class="form-item"  [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
    <div>
      <strong>{{fieldSubmission.field.label}}</strong>
      <span class="form-ast" [hidden]="!fieldSubmission.field.mandatory"> * </span>
    </div>
  </div>
 <span *ngIf="notMatchingWarning"> NOT MATCHOINGGGGGGG </span>
  <div class="form-content" [ngClass]="{'invalid-field': !valid && fieldSubmission.field.mandatory}">
    <ng-container *ngIf="!selectedArtwork; else selectionDone">
      <div class="search-bar-field-label-box">
        <div class="search-bar-field-label">
          <core-label *ngFor=" let staticTag of staticFilterTags"
            [label]="staticTag" 
          ></core-label>
          <core-label-action *ngFor=" let tag of localFilterTags"
            [label]="tag" 
            (actionClick)="onRemoveFilter(tag)"
          ></core-label-action>
        </div>
        <input type="text" [formControl]="searchControl" [placeholder]="placeholder">
      </div>
      <div class="results results-select">

          <ng-container *ngIf="resultsReady; else searchingArtworks" >
            <ng-container *ngIf="results.length > 0; else awNoResutls" >
              <ul class="artwork-form-list">
                <li *ngFor="let version of results" >
                  <!-- [listItemModeOnly]="true" -->
                  <core-versions-summary-box
                    [version]="version"
                    [menu]="menu"
                    [feedbacks]="[]"
                    [exclude]="localFilterTags"
                    (menuClick)="onMenuClick($event)"
                    (actionFileClick)="onFileClick($event)"
                    (actionLabelClick)="onTagSelected($event)"
                  ></core-versions-summary-box>
                </li>
              </ul>
              <core-helpers-box-alert-message-icon
                  *ngIf="resultsStatus === SEARCH_RESULT_STATUS.DONE"
                  [text]="'There are more matches for your query. Try adding more specific filters or typing a new query.'"
                  [icon]="'warning'"
              ></core-helpers-box-alert-message-icon>
            </ng-container>

            <ng-template #awNoResutls> 
              <core-helpers-box-alert-message-icon
                  [text]="'There are no matches for your query. Try removing filters or typing a new query.'"
                  [icon]="'warning'"
              ></core-helpers-box-alert-message-icon>
            </ng-template>
          </ng-container>

          <ng-template #searchingArtworks>
            <div class="loader searching-artworks">
              <div class="dimmed">
                <div class="dimmed_nav">
                  <div class="dimmed_subtitle"></div>
                  <div class="dimmed_subtitle"></div>
                  <div class="dimmed_subtitle"></div>
                  <div class="dimmed_subtitle"></div>
                  <div class="dimmed_subtitle"></div>
                  <div class="dimmed_subtitle"></div>
                  <div class="dimmed_subtitle"></div>
                </div>
              </div>
            </div>
        </ng-template>
      </div>
    </ng-container>
    <!-- When i have already a selected artwork -->
    <ng-template #selectionDone>
        <div class="results results-done">
          <core-versions-summary-box
              [version]="selectedArtwork"
              [menu]="menuSelected"
              [feedbacks]="[]"
              (menuClick)="onMenuClick($event)"
              (actionFileClick)="onFileClick($event)"
            ></core-versions-summary-box>
        </div>
    </ng-template>
    
  </div>
</div>